import { httpsCallable } from 'firebase/functions'

import {
  initFirebase,
  firestoreDb,
  functions,
  auth,
  doesUserExistFBFunction,
  doesAdminUserExistsFbFunction,
  doesOrganizationExistsFbFunction,
  doesTeamExistsFbFunction,
  retrieveChatCredentials,
  createUserFunction,
  updateUserFunction,
  usersCollectionRef,
  organizationsCollectionRef,
  teamsCollectionRef,
  updateAdminUserMetadata,
  userQuestionnairesCollectionRef,
  adminUsersCollectionRef,
  COLLECTIONS,
} from '@edwin/sdk-admin'

import CONFIG from '@config/Config'

const firebaseApp = initFirebase({ config: CONFIG })

const generateTeamQuestionnaireReportFBFunction = httpsCallable(functions, 'generateTeamQuestionnaireReport')

export {
  firebaseApp,
  COLLECTIONS,
  firestoreDb,
  functions,
  auth,
  doesUserExistFBFunction,
  doesAdminUserExistsFbFunction,
  doesOrganizationExistsFbFunction,
  doesTeamExistsFbFunction,
  generateTeamQuestionnaireReportFBFunction,
  retrieveChatCredentials,
  createUserFunction,
  updateUserFunction,
  usersCollectionRef,
  organizationsCollectionRef,
  teamsCollectionRef,
  userQuestionnairesCollectionRef,
  adminUsersCollectionRef,
  updateAdminUserMetadata,
}
